import { useQuery } from "react-query";
import API from "../shared-utils/api";
const getUserFeedbackHistory = async (pubId) => {
    if (!pubId)
        return [];
    const { data } = await API.get("/api/v1/rbzo/reviews/experience/user-history", { params: { pubId } });
    if ((data === null || data === void 0 ? void 0 : data.status_code) === "OK" && Array.isArray(data === null || data === void 0 ? void 0 : data.data)) {
        return data.data;
    }
    return [];
};
export const useUserFeedbackHistory = (pubId, enabled = true) => {
    return useQuery(["userFeedbackHistory", pubId], () => getUserFeedbackHistory(pubId), { enabled: enabled && !!pubId });
};
